import React from 'react';
import { useTheme } from '../../lib/theme';

export function SettingsCard({ title, description, children, testid, actions }) {
  const { colors } = useTheme();
  return (
    <div
      data-testid={testid}
      style={{
        padding: 24, borderRadius: 14,
        border: `1px solid ${colors.border}`, background: colors.surface,
        boxShadow: '0 1px 2px rgba(10,10,10,0.03)',
      }}
    >
      {(title || description || actions) && (
        <div style={{ marginBottom: children ? 16 : 0, display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 16 }}>
          <div style={{ flex: 1 }}>
            {title && <div style={{ fontWeight: 700, color: colors.text, fontSize: 15, letterSpacing: '-0.01em' }}>{title}</div>}
            {description && <div style={{ marginTop: 4, color: colors.textMuted, fontSize: 13, lineHeight: 1.55 }}>{description}</div>}
          </div>
          {actions}
        </div>
      )}
      {children}
    </div>
  );
}

export function SectionShell({ eyebrow, title, description, children, testid }) {
  const { colors } = useTheme();
  return (
    <section data-testid={testid} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <header>
        {eyebrow && <div style={{ color: colors.accent, fontWeight: 700, fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase' }}>{eyebrow}</div>}
        <h2 style={{ margin: '4px 0 0', fontSize: 22, fontWeight: 800, letterSpacing: '-0.02em', color: colors.text }}>{title}</h2>
        {description && <p style={{ color: colors.textMuted, marginTop: 6, fontSize: 14, lineHeight: 1.55 }}>{description}</p>}
      </header>
      {children}
    </section>
  );
}

export function textInput(colors) {
  return {
    display: 'block', width: '100%', boxSizing: 'border-box',
    padding: '10px 12px', borderRadius: 10,
    border: `1px solid ${colors.border}`, background: colors.surface,
    color: colors.text, fontSize: 14, outline: 'none',
  };
}

export function primaryBtn(colors, disabled = false) {
  return {
    padding: '10px 16px', borderRadius: 10, border: 'none',
    background: disabled ? colors.border : colors.accent,
    color: disabled ? colors.textMuted : 'white',
    fontWeight: 700, fontSize: 13, cursor: disabled ? 'not-allowed' : 'pointer',
    boxShadow: disabled ? 'none' : `0 10px 24px -14px ${colors.accent}`,
  };
}

export function outlineBtn(colors) {
  return {
    padding: '10px 16px', borderRadius: 10,
    border: `1px solid ${colors.border}`, background: 'transparent',
    color: colors.text, fontWeight: 600, fontSize: 13, cursor: 'pointer',
  };
}
